import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { RecoveryBoundary } from "./components/RecoveryBoundary.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<RecoveryBoundary><App /></RecoveryBoundary>);
